export const tagToggle = () => {
  const toggle = $('#on-off-switch');
  const container = $('.active-tag');

  if(!toggle.length > 0) return

  const enableInputTag = () => $('.active-tag input').prop('disabled', false);
  const disableInputTag = () => $('.active-tag input').prop('disabled', true);

  if (toggle.is(':checked')) {
    enableInputTag();
    container.removeClass('disabled');
  } else {
    disableInputTag();
  }

  toggle.on('change', (e) => {
    if (toggle.is(':checked')) {
      enableInputTag();
      container.slideDown('fast');
    } else {
      disableInputTag();
      container.slideUp('fast');
    }
  });

}
